import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLang } from "./LanguageContext";

export const DEFAULT_SETTINGS = {
  home_overline: "Advanced Post Graduate Excellence",
  home_title: "Formazione clinica\nd'eccellenza",
  home_subtitle: "Corsi pratici e hands-on con i migliori docenti, su casi clinici reali. Protocolli applicabili subito, gruppi a numero limitato, aggiornamento di alto livello.",
  home_hero_image: "https://images.pexels.com/photos/5355921/pexels-photo-5355921.jpeg",
  home_cta_primary: "Scopri i corsi",
  home_cta_secondary: "Parla con noi",
  home_courses_overline: "In programma",
  home_courses_title: "Corsi attivi",
  home_courses_note: "Solo corsi futuri o attivi. Posti limitati per ogni edizione.",
  footer_brand: "Advanced Post Graduate Excellence",
  footer_description: "Formazione clinica di alto livello per il professionista odontoiatra. Corsi pratici, casi reali, docenti di riferimento.",
  footer_company: "TARGET COMMUNICATIONS SRL",
  footer_iban: "IT68H0503401637000000012812",
  footer_copyright: "Advanced Post Graduate Excellence. Tutti i diritti riservati.",
};

const SettingsContext = createContext(DEFAULT_SETTINGS);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const { lang } = useLang();

  useEffect(() => {
    api
      .get("/settings", { params: { lang } })
      .then((r) => setSettings({ ...DEFAULT_SETTINGS, ...r.data }))
      .catch(() => {});
  }, [lang]);

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
